import { ImportCalloutCardWithoutCCJsData } from '@bingads-webui-campaign-react/import-callout-card';
import { ConversionCallout } from '@bingads-webui-campaign-react/conversion-callout';

export const getAllCallout = props => [
  {
    name: 'conversion-coupon-callout',
    component: ConversionCallout,
    props: {
      preferenceService: props.preferenceService,
      permissions: props.permissions,
    },
    timeout: -1,
    priority: 40,
    sitemapId: 'conversion-goals',
  },
  {
    name: 'import-callout-card',
    component: ImportCalloutCardWithoutCCJsData,
    props: { serverContext: props.serverContext, shouldDisplayDelay: false },
    timeout: -1,
    priority: 30,
    sitemapId: '',
  },
];
